/**
 * Visibility tier — display labels + the lattice helper used by the
 * detail-page card to decide whether a tier change is a downgrade (which
 * requires a fresh value in the same call) or an upgrade (which doesn't).
 *
 * The HTTP wrapper around `PATCH /…/secrets/{path}/visibility` lives in the
 * SDK as `client.secrets.setVisibility(...)`. There is no raw-fetch shim here
 * anymore.
 */

import type { Visibility } from "@wardkey/sdk";

export type { Visibility } from "@wardkey/sdk";

export const VISIBILITY_LABELS: Record<Visibility, string> = {
  open: "open",
  hidden: "hidden",
  sealed: "sealed",
};

export const VISIBILITY_DESCRIPTIONS: Record<Visibility, string> = {
  open: "value shown in the dashboard, no click needed",
  hidden: "dotted out, click to reveal, audit-logged",
  sealed: "never in the dashboard; service tokens only",
};

/** Higher = more restrictive. Used to detect downgrade vs upgrade. */
export function visibilityRank(v: Visibility): number {
  switch (v) {
    case "open":
      return 0;
    case "hidden":
      return 1;
    case "sealed":
      return 2;
  }
}

export function isDowngrade(from: Visibility, to: Visibility): boolean {
  return visibilityRank(to) < visibilityRank(from);
}
